export const allowedRouteList = [
  '/how-it-works/',
  '/who-we-help/',
  '/why-were-better/',
  '/testimonials/',
  '/faq/',
  '/about/',
  '/about/freedom-debt-relief-and-achieve/',
  '/contact/',
  '/reviews/',
  '/wall-of-fame/',
  '/scam/',
  '/glossary/',
  '/',
]
